import {
  CustomerLocationFields,
  CustomerLocationInput
} from '@/types/graphql/schemaTypes';

function convertCustomerLocationFields(fields: CustomerLocationFields): CustomerLocationInput {
  return {
    customerOrganizationId: fields.customerOrganizationId,
    city: fields.city || '',
    contactName: fields.contactName || '',
    contactNumber: fields.contactNumber || '',
    containerAllowed: fields.containerAllowed || false,
    countryCode: fields.countryCode || '',
    fullAddress: fields.fullAddress || '',
    gmapsData: fields.gmapsData ? { ...fields.gmapsData } : null,
    hasCrane: fields.hasCrane || false,
    hasForklift: fields.hasForklift || false,
    hasParking: fields.hasParking || false,
    memo: fields.memo || null,
    name: fields.name || '',
    region: fields.region || null,
    zipCode: fields.zipCode || ''
  };
}

export { convertCustomerLocationFields };
